import { Box, Button, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useCreateElementContext } from "../Context/CreateElementContext";
import QuizComponent from "../../../Courses/CourseForm/QuizComponent";
import AddLanguageDialog from "../../AddLanguageDialog";
import { setStatus } from "../../../../store/actions/User";
import { useDispatch } from "react-redux";
import { ErrorLabel } from "../../ElementForm";
import { QuizContainer } from "../../../Courses/CourseForm/CourseFormStyles";
import FormComponent from "../../../Common/FormComponent/FormComponent";
import { assessmentDetails } from "../../constants";
import RenderIf from "../../../Common/RenderIf/RenderIf";

const AssessmentContent = ({}) => {
  const { form, options, handleAdd, handleDelete, makeDefaultLanguage } =
    useCreateElementContext();
  const dispatch = useDispatch();

  const handleQuestionAdd = (contentIndex) => {
    const content = form.values.content;
    content[contentIndex].questions = [
      ...(content[contentIndex].questions ?? []),
      {
        question: "",
        type: "SINGLE_CHOICE",
        choices: [],
        answers: [],
      },
    ];
    form.handleValue("content")([...content]);
  };
  const handleQuestionDelete = (contentIndex, questionIndex) => {
    const content = form.values.content;
    content[contentIndex].questions = content[contentIndex].questions.filter(
      (_, index) => index !== questionIndex
    );
    form.handleValue("content")([...content]);
  };

  const handleSelectionChange = (
    contentIndex,
    key,
    value,
    type,
    questionIndex,
    optionIndex
  ) => {
    console.log({ contentIndex, key, value, type, questionIndex, optionIndex });
    const content = form.values.content;
    // check of keys that needs array values
    if (optionIndex !== undefined) {
      if (key === "answers") {
        const answers =
          content[contentIndex].questions[questionIndex][key] ?? [];
        const answer = optionIndex + 1;

        if (!(answer in content[contentIndex].questions[questionIndex])) {
          content[contentIndex].questions[questionIndex][key] = [];
        }
        const isSingle =
          content[contentIndex].questions[questionIndex].type ===
          "SINGLE_CHOICE";

        if (isSingle) {
          content[contentIndex].questions[questionIndex][key] =
            answers?.includes(answer) ? [] : [answer];
        } else {
          content[contentIndex].questions[questionIndex][key] =
            answers?.includes(answer)
              ? answers.filter((item) => item !== answer)
              : [...answers, answer];
        }
      } else {
        content[contentIndex].questions[questionIndex][key][optionIndex] =
          value;
      }
    } else if (key === "type") {
      content[contentIndex].questions[questionIndex][key] = value;
      content[contentIndex].questions[questionIndex]["answers"] = [];
    } else {
      content[contentIndex].questions[questionIndex][key] = value;
    }
    console.log({ content });
    form.handleValue("content")([...content]);
  };

  const handleQuizOptionAddition = (contentIndex, questionIndex) => {
    const content = form.values.content;
    content[contentIndex].questions[questionIndex].choices.push("");
    form.handleValue("content")([...content]);
  };

  const handleQuizOptionDelete = (contentIndex, questionIndex, choiceIndex) => {
    const content = form.values.content;
    content[contentIndex].questions[questionIndex].choices = content[
      contentIndex
    ].questions[questionIndex].choices.filter(
      (_, index) => index !== choiceIndex
    );
    form.handleValue("content")([...content]);
  };

  return (
    <Box display={"flex"} flex={1} flexDirection={"column"} gap={2} mt={2}>
      <BorderedBox display={"flex"} flexDirection={"column"} gap={2}>
        <RenderIf condition={form.values?.content.length === 0}>
          <Typography color="red">
            Please add content in default language{" "}
          </Typography>
        </RenderIf>
        {form.values?.content?.map((item, index) => (
          <Box
            borderBottom={"4px solid #F5F5F5"}
            pb={3}
            display={"flex"}
            flex={1}
            flexDirection={"column"}
            gap={2}
            key={`${index}`}
            position={"relative"}
          >
            {index !== 0 && (
              <Box
                sx={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  display: "flex",
                  gap: 2,
                }}
              >
                <Button
                  variant="text"
                  color="error"
                  onClick={() => makeDefaultLanguage(index)}
                >
                  Mark it as default language
                </Button>
                <Button
                  variant="text"
                  color="error"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </Button>
              </Box>
            )}
            <Typography
              variant="h6"
              color="GrayText"
              sx={{ textTransform: "uppercase", letterSpacing: 3 }}
            >
              CONTENT:{" "}
              {
                options?.languages?.find(
                  (lang) => lang.value === item.lang_code
                )?.label
              }{" "}
              {index === 0 && "(DEFAULT)"}
            </Typography>
            {<ErrorLabel label={form.errors.content} />}
            <QuizContainer>
              <Box
                display={"flex"}
                gap={2}
                flexDirection={"column"}
                flex={1}
                maxWidth={"520px"}
                py={2}
              >
                {assessmentDetails
                  .map((item) => ({
                    ...item,
                    id: `content.${index}.${item.id}`,
                  }))
                  .map((item) => (
                    <Box>
                      <FormComponent
                        config={item}
                        form={form}
                        key={item.id}
                        otherOptions={
                          options[item?.props?.optionsKey ?? item.id]
                        }
                      />
                      <ErrorLabel label={form.errors[item.id]} />
                    </Box>
                  ))}
              </Box>
              <QuizComponent
                secIndex={index}
                handleSectionChange={handleSelectionChange}
                handleQuizQuestionAddition={handleQuestionAdd}
                handleQuizQuestionDelete={handleQuestionDelete}
                handleQuizOptionAddition={handleQuizOptionAddition}
                handleOptionDelete={handleQuizOptionDelete}
                disableQuestionEditing={() => false}
                state={"create"}
                items={item.questions}
                type={form.values.assessment_type?.toLocaleLowerCase()}
                singleChoiceValue="SINGLE_CHOICE"
                multipleChoiceValue="MULTIPLE_CHOICE"
                showAudioLink
              />
            </QuizContainer>
          </Box>
        ))}
      </BorderedBox>
      <AddLanguageDialog
        options={options.languages}
        title={
          form?.values?.content?.length === 0
            ? "Add a default language"
            : "Add additional language"
        }
        onSelect={(language) => {
          const languagesAlreadyAdded = form?.values?.content?.map(
            (item) => item.lang_code
          );

          if (languagesAlreadyAdded.includes(language)) {
            dispatch(
              setStatus({
                message:
                  "this language is already added, please select a different language",
                type: "error",
              })
            );
          } else {
            handleAdd(language);
            dispatch(
              setStatus({
                message: "language added",
                type: "success",
              })
            );
          }
        }}
      />{" "}
      {form?.values?.content?.length === 0 && (
        <Box textAlign={"center"}>
          <ErrorLabel label={form.errors.content} />
        </Box>
      )}
    </Box>
  );
};

export default AssessmentContent;

const BorderedBox = styled(Box)`
  background: #fcfcfc;
  border: 1px solid #cfcfcf;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 30px;
`;
